import {MPInsertDataChecked} from "../../marketing-purchase/models/m-p-insert-data-checked";
import {MPDistributionData} from "../../marketing-purchase/models/m-p-distribution-data";
import {TranslateService} from "@ngx-translate/core";
import {MainHelper} from "../../shared/models/main-helper";
import {SCTimeEditor} from "../../supply-schedules/models/s-c-time-editor";
import * as moment from 'moment';
import {ScheduleType} from "../../supply-schedules/models/sched-type";
import {OrderOpened} from "../../orders/models/order-opened";
import {OrderItemOpened} from "../../orders/models/order-item-opened";
import {OrderItemNew} from "../../orders/models/order-item-new";
import {NumericEditor} from "./numeric-editor";
import {number} from "@amcharts/amcharts4/core";
import {TimeEditor} from "./time-editor";
import {ManualOrdersOrder} from "../../orders/models/manual-orders-order";

export class Validators{
    constructor(private readonly translateService: TranslateService){
        this.helper = new MainHelper();
        this.translates = {};
        this.setTranslates(['MP_PackageEditError', 'MP_PackageEditError', 'EnterNumberValueFromZeroTo',
            'StringMustContainValue', 'WrongDate', 'SelectDay', 'SelectValueWithPresentTime', 'Orders_CheckOrder', 'Package',
            'Orders_NearestValue', 'NegativeEditError'
        ])
    }

    private readonly translates: { [key: string]: string };

    private helper: MainHelper;

    public setTranslates = async (keys: string[]): Promise<void> => {
        await this.helper.updateTranslates(this.translateService, keys, this.translates);
    }

    public readonly notAllowZeroNumberValidatorMPCheckPackage = (value, item: MPInsertDataChecked): Slick.ValidateResults => {
        if (value > 0 && (item.package_1 === null || value >= Number(item.package_1))){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: 'MP_PackageEditError'};
        }
    }

    public readonly notAllowZeroNumberValidatorMPCheckPackage2 = (value, item: MPDistributionData): Slick.ValidateResults => {
        if (value === '0' || value === 0 || (item._package === null || value >= Number(item._package) && value % Number(item._package) === 0)){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: 'MP_PackageEditError'};
        }
    }

    //# validator
    public readonly notAllowZeroNumberValidator = (value, msg?: string, editor?: any): Slick.ValidateResults => {

        let result: Slick.ValidateResults;
        if (value > 0){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: msg && typeof msg === 'string'? msg : 'LessOneEditError'};
        }

        if (!result.valid && editor && editor.showError)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    //# validator
    public readonly notAllowZeroNumberValidatorMax31 = (value): Slick.ValidateResults => {
        if (value > 0 && value <= 31){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: 'LessOneMore31'};
        }
    }

    public readonly notAllowZeroNumberValidatorMax24AllowNull = (value): Slick.ValidateResults => {
        if (!value && value !== 0 || value > 0 && value <= 24 && Number.isInteger(Number(value))){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: 'LessOneMore24'};
        }
    }

    //# validator
    public readonly allowMinOneNumberValidatorMax31 = (value): Slick.ValidateResults => {
        if (value >= -1 && value <= 365 || value === null){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: 'LessMinOneMore31'};
        }
    }

    //# validator
    public readonly notAllowZeroNumberValidator365 = (value): Slick.ValidateResults => {
        if (value > 0 && value <= 365){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: 'LessZeroMore365'};
        }
    }

    //# validator
    public readonly allowMinOneNumberValidatorMax365 = (value): Slick.ValidateResults => {
        if (value >= -1 && value <= 365 || value === null){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: 'LessMinOneMore365'};
        }
    }

    //# validator
    public readonly allowMinOneNumberValidator = (value, msg: string): Slick.ValidateResults => {
        if (value >= -1){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: msg ? msg : 'MinOneEditError'};
        }
    }

    //# validator
    public readonly allowZeroNumberValidator = (value, item?: any, editor?: any): Slick.ValidateResults => {
        let result: Slick.ValidateResults;

        if (value > 0 || value === 0 || value === '0'){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'NegativeEditError'};
        }

        if (!result.valid && editor && editor.showError)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    //# validator
    public readonly allowZeroNullNumberValidator = (value, msg?: string): Slick.ValidateResults => {
        if (value > 0 || value === 0 || value === '0' || value === null){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: msg ? msg : 'NegativeEditError'};
        }
    }

    //# validator
    public readonly allowNegativeNumberValidator = (value): Slick.ValidateResults => {
        if (value > 0 || value < 0 || value === 0 || value === '0'){
            return {valid: true, msg: null};
        } else{
            return {valid: false, msg: null};
        }
    }

    //# validator
    public readonly notAllowTextNull = (val, item?, editor?, outerData?: any): Slick.ValidateResults => {
        let result: Slick.ValidateResults;
        if (val){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'EnterTextValue'};
        }

        if (!result.valid && editor && editor.showError)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    public readonly notAllowTimeNull = (val, item?, editor?, outerData?: any): Slick.ValidateResults => {
        // console.log(val, item, editor, 'notAllowTimeNull')
        let result: Slick.ValidateResults;
        if (val){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'SelectValueWithPresentTime'};
        }

        if (!result.valid && editor && editor.showError)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    public readonly allowTimeNull = (val, item?, editor?, outerData?: any): Slick.ValidateResults => {
        // console.log(val, item, editor, 'notAllowTextNull')
        let result: Slick.ValidateResults;
        // if (val){
            result = {valid: true, msg: null};
        // } else{
        //     result = {valid: false, msg: 'EnterTextValue'};
        // }

        if (!result.valid && editor && editor.showError)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    public readonly notAllowEmailNull = (val: string, item?, editor?, outerData?: any): Slick.ValidateResults => {
        let regExp: RegExp = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, 'g'),
            regRes,
            result: Slick.ValidateResults;

        if (val){
            regRes = val.match(regExp)
        }

        if (val && regRes && regRes.length){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'EmailIsNotValid'};
        }

        if (!result.valid && editor && editor.showError)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    public readonly allowEmailNull = (val: string, item?, editor?, outerData?: any): Slick.ValidateResults => {
        // console.log(val, item, editor, 'notAllowTextNull')
        // let regExp: RegExp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, 'g');
        let regExp: RegExp = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, 'g'),
            regRes,
            result: Slick.ValidateResults;

        if (val){
            regRes = val.match(regExp)
        }
        if (!val || regRes && regRes.length){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'EmailIsNotValid'};
        }

        if (!result.valid && editor && editor.showError)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    public readonly allowPhoneNull = (val: string, item?, editor?, outerData?: any): Slick.ValidateResults => {
        // console.log(val, item, editor, 'notAllowTextNull')
        // let regExp: RegExp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, 'g');
        let regExp: RegExp = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, 'im'),
            regRes,
            result: Slick.ValidateResults;

        if (val){
            regRes = val.match(regExp)
        }
        if (!val || regRes && regRes.length){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'PhoneIsNotValid'};
        }

        if (!result.valid && editor && editor.showError)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    //# validator
    private readonly allowNegativeNumberValidatorErr = (val, item, editor): Slick.ValidateResults => {
        let result: Slick.ValidateResults;
        val = +val;
        if (val > 0 || val < 0 || val === 0 || val === '0'){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'EnterNumber'};
        }
        if (!result.valid)
            this.translateService.get(result.msg).subscribe(editor.showError);
        return result;
    }

    //# validator
    public readonly arriveOrderTimesNumberValidator = (val, item?, editor?, arr?: number[]): Slick.ValidateResults => {
        let result: Slick.ValidateResults;
        val = +val;
        if (val > 0 && val <= arr.length){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: this.translates['EnterNumberValueFromZeroTo'] + arr.length};
        }

        return result;
    }

    //# validator
    public readonly hasWarehouseDataInArr = (val: string, item?, editor?, outerData?: { separator: string[], search: string[] }): Slick.ValidateResults => {
        if (!outerData){
            return;
        }

        let result: Slick.ValidateResults,
            data = this.helper.multipleSeparate(val, outerData.separator),
            search = outerData.search.map(s => s);


        if (data && data.length){
            data.forEach(d => {
                let rem: string = '';
                search.some((s) => {
                    if (s === d){
                        rem = s
                        return true;
                    }
                })
                    ? this.helper.remFromArrSimple(search, rem)
                    : null;
            })
            result = search.length
                ? {valid: false, msg: `${this.translates['StringMustContainValue']} ${search.join('; ')}`}
                : {valid: true, msg: null};

        } else{
            result = {valid: false, msg: `${this.translates['StringMustContainValue']} ${outerData.search.join('; ')}`};
        }

        // console.log(result, 'hasWarehouseDataInArr')

        return result;
    }

    //# validator
    public readonly  arriveOrderTimesNumberValidator2 = (val: number, editor: SCTimeEditor<any>): Slick.ValidateResults => {

        let result: Slick.ValidateResults,
            items = editor.args.grid.getData().getItems();
            // selectedTimes = items.filter(item => item.type === (editor.type === 'orders' ? 200 : 300)).map(item => item[editor.args.column.id]).filter(si => si),
            // selectedTimes2 = items.filter(item => item.type === (editor.type === 'orders' ? 200 : 300));

        const validate = (val: number): boolean => {
            return !val && editor.scheduleType !== ScheduleType.MassEdit ||
                   !val && editor.scheduleType === ScheduleType.MassEdit && editor.lines[editor.args.column.id] < editor.maxLines
        }
        // console.log(val, selectedTimes, selectedTimes2, items, editor.args.column.id, validate(val), 'arriveOrderTimesNumberValidator2')
        // todo Remove after fix in back GSSCHED-291 bug 4
        if (validate(val)){
        //if (!val){
            result = {valid: false, msg: this.translates['SelectValueWithPresentTime']};
        } else{
            result = {valid: true, msg: null};
        }

        if (!result.valid)
            editor.showError(this.translates['SelectValueWithPresentTime']);
        return result;
    }

    //# validator
    public readonly dateValidator = (val: string): Slick.ValidateResults => {
        // console.log(val, 'dateValidator')
        let result: Slick.ValidateResults;

        // console.log(val, this.helper.getLocale(this.translateService.currentLang), this.translateService.currentLang, 'dateValidator')

        if (moment(val, this.helper.getLocale(this.translateService.currentLang),true).isValid() || val === '' || val === null){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'WrongDate'};
        }

        // console.log(val, result, 'dateValidator 2')

        return result;
    }

    //# validator
    public readonly openOrderValidator = (val: string, item: OrderOpened, editor: any, outerData: string): Slick.ValidateResults => {
        let result: Slick.ValidateResults,
            convertedData = moment.utc(val, this.helper.getLocale(this.translateService.currentLang)).format();
        if (moment(convertedData).isSameOrAfter(moment(outerData), 'day')){
            result = {valid: true, msg: null};
        } else{
            result = {valid: false, msg: 'Orders_CheckArrivalDate'};
        }
        return result;
    }

    //# validator
    public readonly itemOrderValidator = (value: number, item: OrderItemNew | OrderItemOpened | ManualOrdersOrder, checkForRemainder: boolean): Slick.ValidateResults => {
        let result: Slick.ValidateResults,
            remainder = Math.round((value % item.packageValue)*100)/100;
        remainder > 0 && remainder - item.packageValue === 0 ? remainder = 0 : null;
        if (value >= 0 && (remainder === 0 || !checkForRemainder)){
            result = {valid: true, msg: null};
        } else if (value < 0){
            result = {valid: false, msg: this.translates['NegativeEditError']};
        } else {
            let min = value - remainder,
                max = value + item.packageValue - remainder;
            result = {
                valid: false,
                msg: `${this.translates['Orders_CheckOrder']}, ${this.translates['Package'].toLowerCase()} - ${item.packageValue}.
                 ${this.translates['Orders_NearestValue']}: ${min.toFixed(2)}, ${max.toFixed(2)}.`};
        }
        // editor && !result.valid && editor.showError(this.translates[result.msg])
        return result;
    }

    public readonly timeValidator = (val: string, item: any, editor: TimeEditor<any>): Slick.ValidateResults => {
        let result: Slick.ValidateResults,
            params = editor.validationParams,
            hour = MainHelper.getHourFromInput(val);

        if (editor.allowNull && (val === '' || val === null) ){
             result = {valid: true, msg: null};
        } else {
            if (params && params.timeList && params.timeList.length){
                result = params.timeList.some(tl => tl === hour)
                    ? {valid: true, msg: null}
                    : {valid: false, msg: 'SelectValueWithPresentTime'}
            }

            if (params && params.startTime && params.endTime){
                result = hour >= params.startTime && hour <= params.endTime
                    ? {valid: true, msg: null}
                    : {valid: false, msg: 'SelectValueWithPresentTime'}
            }
        }



        if (!result.valid)
            editor.showError(this.translates['SelectValueWithPresentTime']);
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/validators.ts